import Logger from './Logger'
import { LOGGER_LEVEL, LOGGER_PREFIX } from './constant'

const logger = new Logger(LOGGER_PREFIX, LOGGER_LEVEL)

export default logger
